import React, { useCallback, useEffect, useRef, useState } from "react";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { getTransactionFilters } from "../../../Infrastructure/Services/TransactionService";
import { toast } from "react-toastify";
import UILabelInput from "../../../Domain/Components/UI/LabelInput/LabelInput";
import { inputType } from "../../../Domain/Constants/InputType";
import UIMultiselectModal from "../../../Domain/Components/UI/MultiSelectModal/MultiselectModal";
import UIButton from "../../../Domain/Components/UI/Button/Button";
import { styleType } from "../../../Domain/Constants/StyleType";
import { getChildrenList, hideDuplicates, prepareJsonArray } from "../../../Domain/Helpers/MultiselectHelper";
import usePagination from "../../../Infrastructure/Hooks/usePagination";
import UITable from "../../../Domain/Components/UI/Table/Table";

function GameConfigList(props) {
    const [filters, setFilters] = useState(null);
    const [casinos, setCasinos] = useState();
    const [agregators, setAgregators] = useState();
    const [providers, setProviders] = useState();
    const [gameConfigs, setGameConfigs] = useState();
    const [searchValues, setSearchValues] = useState("");
    const [page, setPage] = useState(1);
    const [formJsonBody, setFormJsonBody] = useState({});
    const [sortChangedOnFirstPage, setSortChangedOnFirstPage] = useState(0)
    const { data, more, loading, error } = usePagination(page, 100, "game-config/read", null, sortChangedOnFirstPage, props.setLoggedIn, [], false, null, formJsonBody, false);

    useEffect(() => {
        const token = getWithExpiry("token");
        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        getTransactionFilters(token).then((data) => {
            if (data) {
                setFilters(data);
            } else {
                toast.error("Failed to retreive Game Session filter data");
                setFilters({});
            }
        })
    }, []);

    useEffect(() => {
        if (filters && filters.operators) {
            let tmpCasinos = [];

            filters.operators.forEach(o => {
                tmpCasinos = tmpCasinos.concat(o.casinos);
            });

            setCasinos(tmpCasinos);
        }
    }, [filters]);

    const onOperatorsSelected = () => {
        setTimeout(() => {
            let tmpCasinos = getChildrenList(filters.operators, "operators", "casinos");

            setCasinos(tmpCasinos);
        }, 1000)

    }

    useEffect(() => {
        if (casinos) {
            let tmpAgregators = getChildrenList(casinos, "casinos", "providers")
            setAgregators(tmpAgregators);
        }
    }, [casinos])

    useEffect(() => {
        if (agregators) {
            let tmpProviders = [];
            agregators.forEach(element => {
                const providers = Object.values(element.providers);
                tmpProviders.push(...providers);
            });
            setProviders(tmpProviders);
        }
    }, [agregators])

    const onCasinosSelected = () => {
        setTimeout(() => {
            let tmpAgregators = getChildrenList(casinos, "casinos", "providers")
            setAgregators(tmpAgregators);
        }, 1000)
    }

    useEffect(() => {
        if (providers) {
            let gameConfigsTmp = [];
            providers.forEach(element => {
                gameConfigsTmp.push(...element.games);
            });
            setGameConfigs(gameConfigsTmp);
        }
    }, [providers])

    const onSearchInputChange = (e) => {
        const inputVal = e.target.value;
        if (!inputVal || inputVal === "") {
            setSearchValues({});
        }
    }

    const onFilterFormSubmit = (e) => {
        e.preventDefault();
        let token = getWithExpiry('token');
        if (token === null) {
            props.setLoggedIn(false);
            return;
        }
        if (page !== 1) setPage(1);

        const form = e.target;
        const formData = new FormData(form);
        let formJson = prepareJsonForSending(formData);
        setFormJsonBody(formJson);
    }

    const prepareJsonForSending = (formData) => {
        let formJson = Object.fromEntries(formData.entries());
        formJson.columnName = "created_at";

        for (var key in formJson) {
            if (formJson[key] === "") delete formJson[key];
        }

        formJson.operators = prepareJsonArray(formJson, "operators", true);
        formJson.casinos = prepareJsonArray(formJson, "casinos", true);
        formJson.providers = prepareJsonArray(formJson, "providers", true);
        formJson.agregators = prepareJsonArray(formJson, "agregators", true);

        return formJson;
    }

    const observer = useRef();
    const lastElementRef = useCallback((element) => {
        if (observer.current) observer.current.disconnect();
        if (!more) return;
        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && more) setPage((prev) => prev + 1);
        });
        if (element) observer.current.observe(element);
    }, [more]);

    return (
        <>
            <div className="container">
                <div className="d-flex justify-content-between">
                    <h3>Game Configs</h3>
                </div>
                <div className="mt-2">
                    {filters === null ?
                        <div className="w-100 mt-4 d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div> :
                        Object.keys(filters).length === 0 ? <p className="text-danger">Failed to load filters</p> :
                            <form className="row" method="post" onSubmit={onFilterFormSubmit}>
                                <div className="col-md-4">
                                    <UIMultiselectModal title={"Operators"}
                                        id={"operators"}
                                        options={filters.operators}
                                        displayKey={"company_name"}
                                        onConfirm={onOperatorsSelected} />
                                    <UIMultiselectModal title={"Casinos"}
                                        id={"casinos"}
                                        options={casinos}
                                        displayKey={"company_name"}
                                        onConfirm={onCasinosSelected} />
                                </div>
                                <div className="col-md-4">
                                    <UIMultiselectModal title={"Agregators"}
                                    id={"agregators"}
                                    options={hideDuplicates(agregators)}
                                    displayKey={"name"}
                                    onConfirm={() => {}} />
                                <UIMultiselectModal title={"Vendors"}
                                    id={"providers"}
                                    options={hideDuplicates(providers)}
                                    displayKey={"name"}
                                    onConfirm={() => {}} />
                                </div>
                                <div className="col-md-4">
                                    <div className="col-10">
                                        <input style={{marginTop: "10px"}} name="searchValues" id="searchValues" className="form-control" type="search" placeholder="Search..." aria-label="Search" 
                                        onChange={onSearchInputChange}/>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                <UIButton buttonType={"submit"} buttonText={"SEARCH"} styleType={styleType.FADEBLACK} additionalClass="w-100" />
                                </div>
                            </form>
                    }
                </div>
                <div className='mt-3'>
                        <UITable columnTitles={[
                                "ID", "Name", "Vendor", "Agregator"
                            ]}
                            data={data}
                            objectKeys={["id", "name", "provider.name", "provider.parent_provider.name"]}
                            primaryKey={'id'}
                            lastElementRef={lastElementRef}
                            detailsHref={"/game-config/details"}
                            preventDelete={true}
                        ></UITable>
                        {loading & (more || page === 1) ? <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div> : <span></span>}
                        {!more && !loading && <p className='text-center p-4 text-secondary font-weight-bold'>No more data to be loaded</p>}
                    </div>
            </div>
        </>
    )
}

export default GameConfigList;